import React from 'react';
import * as Scroll from 'react-scroll';

const ReactScrollLink = Scroll.Link;

const BlockScrollBannerSelect = ({ blockData }) => (
    <div className='comp-wrap flex' data-comp={BlockScrollBannerSelect.displayName}>
        <div
            className='flex'
            style={{
                width: '100%',
                margin: '0 auto',
                justifyContent: 'space-evenly',
                alignItems: 'center'
            }}
        >
            {blockData
                && blockData.map((block, i) => (
                    <ReactScrollLink
                        key={i}
                        activeClass='active'
                        to={block?.title}
                        // hashSpy={true}
                        // spy={true}
                        smooth={true}
                        offset={-80}
                        duration={500}
                    >
                        <span className='top-link'>{block.menuName}</span>
                    </ReactScrollLink>
                ))}
        </div>
        <style jsx>{`
            .comp-wrap {
                justify-content: space-between;
                height: 60px;
                margin-bottom: 24px;
                width: 100%;
                background-color: #f9f9f9;
                @media (max-width: 991.98px) {
                    display: none;
                }
            }

            .top-link {
                color: #4f4f4f;
                text-decoration-color: transparent;
                text-decoration: none;
                cursor: pointer;
                transition: color 200ms ease-out;

                &:hover {
                    color: #121651;
                    font-weight: 600;
                    text-decoration: underline;
                }
            }

            .scroll-banner-row {
                align-items: center;
                padding: 0px 20px;
            }
        `}</style>
    </div>
);

export default BlockScrollBannerSelect;
BlockScrollBannerSelect.displayName = 'BlockScrollBannerSelect';
